import api from './api';
import API_ROUTES from './apiRoutes';

const messageService = {
  getMyConversations: (type) => api.get(API_ROUTES.CONVERSATIONS.MY_CONVERSATIONS(type)),
  startConversation: (data) => {
    if (data instanceof FormData) {
      return api.post(API_ROUTES.CONVERSATIONS.START, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return api.post(API_ROUTES.CONVERSATIONS.START, data);
  },
  deleteConversations: (conversationIds) => api.delete(API_ROUTES.CONVERSATIONS.DELETE, { data: { conversationIds } }),
  archiveConversations: (conversationIds) => api.patch(API_ROUTES.CONVERSATIONS.ARCHIVE, { conversationIds }),
  unarchiveConversations: (conversationIds) => api.patch(API_ROUTES.CONVERSATIONS.UNARCHIVE, { conversationIds }),
  getMessages: (conversationId, page, limit) => api.get(API_ROUTES.MESSAGES.GET(conversationId, page, limit)),
  sendMessage: (data) => {
    if (data instanceof FormData) {
      return api.post(API_ROUTES.MESSAGES.SEND, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return api.post(API_ROUTES.MESSAGES.SEND, data);
  },
  markAsRead: (conversationId) => api.patch(API_ROUTES.MESSAGES.MARK_READ, { conversationId }),
  deleteMessage: (messageId) => api.delete(API_ROUTES.MESSAGES.DELETE(messageId)),
  // Get followed players for "Send a Message" modal
  getFollowedPlayersForMessaging: (userRole, params = {}) => {
    const route = userRole === 'scout'
      ? API_ROUTES.SCOUT.FOLLOWED_PLAYERS_FOR_MESSAGING(params)
      : API_ROUTES.COACH.FOLLOWED_PLAYERS_FOR_MESSAGING(params);
    return api.get(route);
  },
};

export default messageService;
